import type { ISettingMaster } from "@bbj-types/setting";
import { IconFromName } from "@data-display/icon/IconSVG";
import ClearIcon from "@mui/icons-material/ClearOutlined";
import DoneIcon from "@mui/icons-material/Done";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import type { TPaperCandidateChallengeAction } from "../types";
import { paperCandidateChallengeActionCardClasses } from "./styles";

export interface IPaperCandidateChallengeActionIconProps {
  action: Pick<TPaperCandidateChallengeAction, "status" | "contactChannel">;
  actionChannels?: ISettingMaster["values"];
}

export const PaperCandidateChallengeActionIcon = ({
  action,
  actionChannels,
}: IPaperCandidateChallengeActionIconProps) => {
  const contactChannelIcon = actionChannels?.find((channel) => channel.value === action.contactChannel)?.icon;
  if (contactChannelIcon) {
    return <IconFromName className={paperCandidateChallengeActionCardClasses.icon} icon={contactChannelIcon} />;
  }
  switch (action.status) {
    case "todo":
      return <TripOriginIcon className={paperCandidateChallengeActionCardClasses.icon} />;
    case "done":
      return <DoneIcon className={paperCandidateChallengeActionCardClasses.icon} />;
    default:
      return <ClearIcon className={paperCandidateChallengeActionCardClasses.icon} />;
  }
};
